const root = document.documentElement;

if (root.dataset.taoMockupHeaderReady !== 'true') {
  root.dataset.taoMockupHeaderReady = 'true';

  let nav = document.querySelector('[data-tao-mockup-header]');
  let announcementGroup = document.querySelector('[data-tao-announcement-group]');
  let announcement = announcementGroup?.querySelector('.announcement-bar');
  let menu = document.querySelector('[data-tao-mobile-menu]');
  let sheet = menu?.querySelector('[data-tao-mobile-menu-sheet]');
  let menuOpen = false;
  let priorFocus = null;
  let headerFrame = 0;
  let announcementHeight = 0;
  let navHeight = 0;
  let stickyNav = false;   /* phones on the mockup pages: CSS pins the nav (position: sticky), no transforms here */
  let pageRange = 1;
  let cartCount = Number(document.querySelector('[data-content="mockup-cart-count"]')?.dataset.count || 0);

  function refreshHeaderElements() {
    nav = document.querySelector('[data-tao-mockup-header]');
    announcementGroup = document.querySelector('[data-tao-announcement-group]');
    announcement = announcementGroup?.querySelector('.announcement-bar');
    menu = document.querySelector('[data-tao-mobile-menu]');
    sheet = menu?.querySelector('[data-tao-mobile-menu-sheet]');
  }

  function updateHeaderGeometry() {
    if (!nav) return;

    announcementHeight = announcement?.getBoundingClientRect().height || 0;
    navHeight = nav.getBoundingClientRect().height;
    stickyNav = window.getComputedStyle(nav).position === 'sticky';
    pageRange = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);

    queueHeaderPosition();
  }

  function readScrollPosition() {
    const lockedBodyTop = Number.parseFloat(document.body.style.top);

    if (document.body.style.position === 'fixed' && Number.isFinite(lockedBodyTop)) {
      return Math.max(0, -lockedBodyTop);
    }

    return Math.max(0, window.scrollY);
  }

  function updateHeaderPosition() {
    headerFrame = 0;
    if (!nav) return;

    const scrollPosition = readScrollPosition();
    const announcementTravel = Math.min(scrollPosition, announcementHeight);
    const announcementOffset = Math.max(0, announcementHeight - scrollPosition);
    const announcementVisible = announcementOffset > 0.5;
    const overlayPage = Boolean(document.querySelector(
      '#MainContent[data-tao-mockup-home], #MainContent[data-tao-mockup-product]'
    ));
    const hasMobileProductBuffer = window.matchMedia('(max-width: 920px)').matches
        && Boolean(document.querySelector('[data-tao-mockup-product]'));
    const backgroundThreshold = hasMobileProductBuffer ? 124 : 24;
    const opaque = !overlayPage || scrollPosition > backgroundThreshold || menuOpen;
    const pageProgress = Math.min(1, Math.max(0, scrollPosition / pageRange));

    if (stickyNav) {
      /* the announcement scrolls away in flow and the nav is pinned by CSS; an inline
         transform left over from a wider layout would fight that */
      if (announcementGroup && announcementGroup.style.transform) announcementGroup.style.transform = '';
      if (nav.style.transform) nav.style.transform = '';
    } else {
      if (announcementGroup) {
        announcementGroup.style.transform = `translateY(${-announcementTravel}px)`;
      }
      nav.style.transform = `translateY(${announcementOffset}px)`;
    }
    nav.classList.toggle('is-scrolled', opaque);
    nav.dataset.state = opaque ? 'opaque' : 'transparent';
    nav.dataset.announcementVisible = String(announcementVisible);
    nav.querySelector('.nav-progress')?.style.setProperty(
      'transform',
      `scaleX(${pageProgress.toFixed(4)})`
    );
  }

  function renderCartCount(count) {
    const badge = document.querySelector('[data-content="mockup-cart-count"]');
    const button = badge?.closest('[data-action="mockup-cart:open"]');
    if (!badge || !button) return;

    cartCount = Math.max(0, Number(count) || 0);
    badge.dataset.count = String(cartCount);
    badge.textContent = cartCount > 99 ? '99+' : String(cartCount);
    badge.hidden = cartCount === 0;
    button.setAttribute('aria-label', `Bag, ${cartCount} ${cartCount === 1 ? 'item' : 'items'}`);
  }

  function handleCartUpdate(event) {
    const itemCount = Number(event.detail?.data?.itemCount);
    if (!Number.isFinite(itemCount)) return;

    const fromProductForm = event.detail?.data?.source === 'product-form-component';
    renderCartCount(fromProductForm ? cartCount + itemCount : itemCount);
  }

  function handleOfferCartResolved(event) {
    const itemCount = Number(event.detail?.cart?.item_count);
    if (!Number.isFinite(itemCount)) return;

    renderCartCount(itemCount);
  }

  function queueHeaderPosition() {
    if (!headerFrame) headerFrame = window.requestAnimationFrame(updateHeaderPosition);
  }

  function checkHasBlockingOverlay() {
    return Boolean(document.querySelector(
      'custom-modal[open], dialog[open][scroll-lock], details[open][scroll-lock]'
    ));
  }

  function updateRootScrollLock(shouldLock) {
    const isLocked = shouldLock || checkHasBlockingOverlay();

    root.toggleAttribute('scroll-lock', isLocked);
    root.classList.toggle('scroll-lock', isLocked);
  }

  function updateMenu(open, restoreFocus = true) {
    const button = document.querySelector('[data-action="mockup-menu:toggle"]');
    if (!nav || !menu || !sheet || menuOpen === open) return;

    menuOpen = open;
    if (open) priorFocus = document.activeElement;

    button?.setAttribute('aria-expanded', String(open));
    button?.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    menu.setAttribute('aria-hidden', String(!open));
    sheet.inert = !open;
    nav.classList.toggle('menu-active', open);
    root.classList.toggle('menu-open', open);
    updateRootScrollLock(open);
    queueHeaderPosition();

    if (open) {
      window.requestAnimationFrame(() => {
        menu.querySelector('[data-action="mockup-menu:close"]')?.focus();
      });
    } else if (restoreFocus && priorFocus instanceof HTMLElement) {
      priorFocus.focus({ preventScroll: true });
    }
  }

  function handleDocumentClick(event) {
    const actionTarget = event.target.closest('[data-action]');
    const action = actionTarget?.dataset.action;

    if (action === 'mockup-menu:toggle') {
      updateMenu(!menuOpen);
      return;
    }

    if (action === 'mockup-cart:open') {
      const cartDrawerTrigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
      if (!cartDrawerTrigger) return;

      event.preventDefault();
      cartDrawerTrigger.click();
      return;
    }

    if (action === 'mockup-menu:close' || action === 'mockup-menu:navigate') {
      updateMenu(false, action !== 'mockup-menu:navigate');
      return;
    }

    if (menuOpen && !menu?.contains(event.target) && !nav?.contains(event.target)) {
      updateMenu(false);
    }
  }

  function handleDocumentKeydown(event) {
    if (!menuOpen || !sheet) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      updateMenu(false);
      return;
    }

    if (event.key !== 'Tab') return;

    const focusable = [...sheet.querySelectorAll('a, button:not([disabled])')];
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  const announcementResizeObserver = new ResizeObserver(updateHeaderGeometry);
  if (announcement) announcementResizeObserver.observe(announcement);
  if (nav) announcementResizeObserver.observe(nav);

  document.addEventListener('click', handleDocumentClick);
  document.addEventListener('keydown', handleDocumentKeydown);
  document.addEventListener('cart:update', handleCartUpdate);
  document.addEventListener('offer-engine:cart-resolved', handleOfferCartResolved);
  document.addEventListener('shopify:section:load', () => {
    announcementResizeObserver.disconnect();
    refreshHeaderElements();
    if (announcement) announcementResizeObserver.observe(announcement);
    if (nav) announcementResizeObserver.observe(nav);
    updateHeaderGeometry();
  });
  window.addEventListener('scroll', queueHeaderPosition, { passive: true });
  window.addEventListener('resize', updateHeaderGeometry, { passive: true });
  window.matchMedia('(max-width: 920px)').addEventListener('change', (event) => {
    if (!event.matches) updateMenu(false, false);
  });

  updateHeaderGeometry();
  renderCartCount(cartCount);
}
